/*
 * @Author: Wei Guojun 
 * @Date: 2022-06-23 09:00:07 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2022-06-23 13:18:22
 */

<template>
    <div>
        <projectHeader></projectHeader>
        <div class="top"></div>
        <div class="center">
            <div class="left"></div>
            <div class="aside">
                <div class="goback" @click="goBack"><img src="../assets/images/goback.png"/><span>返回</span></div>
                <div class="title">协议客户资料提交</div>
                <div class="infoBox">
                <div class="infotop">
                    <div class="ImgBox">
                        <img src="../assets/images/kdylogo.png">
                        <div class="name">快递员</div>
                    </div>
                    <div class="nTelAdress">
                        <p>{{ywyinfo.name}}</p>
                        <p>{{ywyinfo.phone}}</p>
                        <p>{{ywyinfo.address}}</p>
                    </div>
                </div>
                </div>
                <el-form :model="form" label-width="150px" :label-position="labelPosition" :rules="rules" ref="zlForm">
                    <!-- <h4>添加快递员手机号码+姓名，极速绑定</h4>
                    <div class="color8">通过添加快递员手机号和姓名可提交绑定，需快递员审核;</div> -->
                    <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.name" placeholder="请输入真实姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="证件号码" prop="number">
                    <el-input v-model="form.number" placeholder="请输入身份证号/台湾、港澳居民来往内地通行证号"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="validCode">
                     <el-input v-model="form.validCode" placeholder="请输入短信验证码">
                        <el-button v-show ="!codeShow" slot="append" @click="getCode">获取验证码</el-button>
                        <el-button v-show ="codeShow" slot="append">{{codeNum}}</el-button>
                     </el-input>
                    </el-form-item>
                    <el-form-item label="商家名称" prop="company">
                    <el-input v-model="form.company" placeholder="请输入商家名称"></el-input>
                    </el-form-item>
                    <el-form-item label="所在地址" prop="address">
                    <el-input v-model="form.address" placeholder="请输入商家所在地"></el-input>
                    </el-form-item>
                    <el-form-item label="申请每日单号限额" prop="dayOrdernum">
                    <el-input v-model="form.dayOrdernum" placeholder="请输入快递员手机号"></el-input>
                    </el-form-item>
                    <div class="flexBox">
                    <el-button type="primary" @click="onSubmit">提交绑定</el-button>
                    </div>
                </el-form>
            </div>
            <div class="right"></div>
        </div>
   
    </div>
</template>
<script>
import projectHeader from "@/components/header";
import bindKdy from "@/api/bindKdy";
import face from '@/api/face';
var codeInterval
export default {
    name:'dataPerfect',
    data(){
        var checkPhone = (rule, value, callback) => {
            if (!value) {
            return callback(new Error('请输入快递员手机号'));
            }
            var phonetest = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|8|9])|(?:5[0-3|5-9])|(?:6[2|5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|3|5|8|9]))\d{8}$/;
            setTimeout(() => {
            if (!phonetest.test(value)) {
                callback(new Error('快递员手机号格式错误'));
            } else {
                callback();
            }
            }, 1000);
        };
        return{
          labelPosition:'right', 
          form:{
            address: '',
            company: "",
            dayOrdernum: 50,
            name: "",
            number: "",
            phone: "",
            validCode:'',
            checked:false,
          },
          ywyinfo:{
            name:'',
            phone:'',
            address:'',
            auth_type:'',
            ywyId:'',
          },
          rules:{
            name: [
                { required: true, message: '请输入姓名', trigger: 'blur' },
                { min: 1, max: 10, message: '姓名应在 1 到 10 个字符', trigger: 'blur' }
            ],
            number:[{ required: true, message: '请输入身份证号码', trigger: 'blur' }],
            phone:[{required: true, validator: checkPhone, trigger: 'blur'}],
            validCode: [
                { required: true, message: '请输入验证码', trigger: 'blur' },
            ],
            company: [
                { required: true, message: '请输入商家名称', trigger: 'blur' },
                { min: 1, max: 10, message: '商家名称长度应在 1 到 10 个字符', trigger: 'blur' }
            ],
          },
          codeShow:false,
          codeNum:'60s',
        }
    },
    components: { projectHeader },
    mounted() {
        this.getNums();
        this.getpeosonInfo();
    },
    methods:{
        goBack(){

        },
        onSubmit(){
          this.$refs.zlForm.validate((valid) => {
            if (valid) {
            //    const query = {...this.phoneAndcode} 
            //    bindKdy.bindingYwyBySmsCode(this,query).then(res=>{
            //     if(res.success){
            //         this.$message.success('绑定成功')
            //     }
            //    })
            } else {
                console.log('error submit!!');
                return false;
            }
          }); 
        },
        //获取手机验证码
        getCode(){
            var phonetest = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|8|9])|(?:5[0-3|5-9])|(?:6[2|5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|3|5|8|9]))\d{8}$/;
            if(this.form.phone == '' || !phonetest.test(this.form.phone)){
            this.$message.error('手机号码错误或未填写');
             return
            }
            this.codeShow = true
            let second = 60;
            this.getCodeFun();
            codeInterval = setInterval(()=>{
            second --
            console.log(second,'second');
            if(second < 0){
                this.codeNum = 60;
                this.codeShow = false
                clearInterval(codeInterval);
            }else{
                this.codeNum = second + 's'
            } 
            },1000)
        },
        getCodeFun(){
            bindKdy.sendmobilemsg(this,this.form.phone).then(res=>{
            if (res.success) {
                this.$message.success('短信已发送，请耐心等待')
            } else {
                this.$message.error(res.body.message)
            }
        })
        },
        //获取上次申请的信息
        getpeosonInfo(){
           bindKdy.queryAccountInfo(this).then(res=>{
            if (res.success) {
                const data = res.data;
                this.form.company = data.company;
                this.form.dayOrdernum = data.estimate_day_order_num || 50;
                this.form.name = data.name;
                this.form.number = data.number;
                this.form.phone = data.phone;
                this.form.address = data.address;  
            }  
        })
        },  
        //获取协议面单信息        
        getNums(){
          face.getbillNum(this).then(res=>{
             if(res.success){
                 const data = res.data;
                 this.ywyinfo.name = data.ywy_name;
                 this.ywyinfo.phone = data.ywy_phone;
                 this.ywyinfo.address = data.branch_name;
                 this.ywyinfo.auth_type = data.auth_type;
                 this.ywyinfo.ywyId = data.ywy_account_id
             }
          }) 
        }
    }
}
</script>
<style lang="stylus" scoped>
.top{width:100%; height:60px; background:#f5f5f5; position:absolute; top:0; left:0;}
.center{width:100%; background:#f5f5f5; position:absolute; top:60px; bottom:0;}
.left{width:20%; height:100%; background:#f5f5f5;; float:left; }
.right{overflow:hidden; height:100%;width:20%;float:left;}
.aside{
    width:60%; 
    height:100%; 
    background:#fff; 
    float:left;
    min-with:1000px;
    border-radius: 8px;
    font-size:14px;
    padding-left: 30px;
    padding-right: 40px;
}
.title{
  margin: 0 100px;  
  font-size: 16px;
  font-weight: bold;
  line-height: 50px;
  border-bottom: 1px solid #f5f5f5;
}
.goback{
    margin: 20px 20px 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    line-height:30px;
    width: 100px;
    cursor pointer
    img{
        width: 30px;
        height: 30px;
    }
    span{
        margin-left: 10px;
        color: #888888;
    }
}
.infoBox{
    font-size 14px  
    padding-top: 30px;
    .infotop{
        display flex;
        justify-content flex-start; 
        padding-bottom  10px;
        padding-top: 10px;
        border-bottom 1px solid #EBEEF5;
        border-top:1px solid #EBEEF5;
        .ImgBox{
            width: 50px;
            height: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow: hidden;       
            img{
                width 100%
            }    
        }  
        .nTelAdress{
            padding-top:4px
            margin-left:30px
            line-height: 24px
            p:nth-of-type(2){
                color #2ea2fc
            }    
        }     
    }
}
</style>